(function () {

$(document).ready(function () {

// Set up scroll effects
AOS.init({
  easing: 'ease-in-out-cubic',
  disable: 'phone',
  duration: '600',
  once: true
});

});

})();


// History SVG graphic
$(document).ready(function () {

var vertical = (function () {
  var grid = document.querySelector('.events');
  var vertical = document.querySelector('.events-vertical');

  var itemRows = 11;
  var branchedItem = 4;
  var branchedItemSpan = 2;
  var itemDisplayRows = itemRows + branchedItemSpan - 1;
  var slant = 1;

  var xmlns = "http://www.w3.org/2000/svg";

  function getGaps() {
    var values = window.getComputedStyle(grid).getPropertyValue("gap")
      .split(" ");

    // It looks like Safari always returns two values, while Chrome can return one
    // if it's the same for both the x axis and the y axis.
    if (values.length == 2) {
      gaps = [parseInt(values[1]), parseInt(values[0])];
    } else {
      gaps = [parseInt(values[0]), parseInt(values[0])]
    }

    return gaps.map(function (value) {
      if (isNaN(value)) {
        return 0;
      }
      return value;
    });
  }

  var gaps = getGaps(grid);
  var xGap = gaps[0];
  var yGap = gaps[1];
  var totalYGap = (itemRows - 1) * yGap;

  var width, height;

  function getPathStrs() {
    var itemHeight = (height - totalYGap) / itemDisplayRows;
    var leftX = (width - xGap) / 4;
    var rightX = 3 * leftX + xGap;
    var xOffset = rightX - leftX;
    var yOffset = slant * xOffset;
    
    function getBranchedItemStartY() {
      return (itemHeight + yGap) * (branchedItem - 1);
    }

    function getBranchedItemEndY() {
      return (itemHeight + yGap) * (branchedItem - 1) + branchedItemSpan * itemHeight;
    }

    var branchStartLeftY = getBranchedItemStartY(branchedItem);
    var branchStartRightY = getBranchedItemStartY(branchedItem) + yOffset;
    var branchEndRightY = getBranchedItemEndY(branchedItem) - yOffset;
    var branchEndLeftY = getBranchedItemEndY(branchedItem);

    var branchingPathStr = "M " + leftX + ", " + (itemHeight / 2) + " L " + leftX + ", " + branchStartLeftY;
    branchingPathStr = branchingPathStr + " C " + leftX + ", " + (branchStartLeftY + 0.5 * yOffset) + " " + rightX + ", " + (branchStartRightY - 0.5 * yOffset) + " " + rightX + ", " + branchStartRightY;
    branchingPathStr = branchingPathStr + " L " + rightX + ", " + branchEndRightY;
    branchingPathStr = branchingPathStr + " C " + rightX + ", " + (branchEndRightY + 0.5 * yOffset) + " " + leftX + ", " + (branchEndLeftY - 0.5 * yOffset) + " " + leftX + ", " + branchEndLeftY;
    branchingPathStr = branchingPathStr + " L " + leftX + ", " + (height - itemHeight / 2);

    var straightPathStr = "M " + leftX + ", " + getBranchedItemStartY() + " L " + leftX + ", " + getBranchedItemEndY();

    return [straightPathStr, branchingPathStr];
  }

  function update() {
    // No need to update when graphic isn't displayed
    if (window.getComputedStyle(vertical).getPropertyValue("display") == "none") {
      return;
    }

    width = vertical.clientWidth;
    height = vertical.clientHeight;
    
    vertical.setAttribute("viewBox", "0 0 " + width + " " + height);

    var pathStrs = getPathStrs();

    var straightPath = vertical.querySelector(".straightPath");
    straightPath.setAttribute("d", pathStrs[0]);

    var branchingPath = vertical.querySelector(".branchingPath");
    branchingPath.setAttribute("d", pathStrs[1]);
  }

  function init() {
    var straightPath = document.createElementNS(xmlns, "path");
    straightPath.classList.add("straightPath");
    vertical.appendChild(straightPath);

    var branchingPath = document.createElementNS(xmlns, "path");
    branchingPath.classList.add("branchingPath");
    vertical.appendChild(branchingPath);

    update();
  }

  return {
    init: init,
    update: update
  };
})();

vertical.init();

var eventGraphics = (function () {
  var xmlns = "http://www.w3.org/2000/svg";

  function updateDateGraphic(svg) {
    // No need to update when graphic isn't displayed
    if (window.getComputedStyle(svg).getPropertyValue("display") == "none") {
      return;
    }

    var path = svg.querySelector("path");
    var circle = svg.querySelector("circle");

    var width = svg.clientWidth;

    svg.setAttribute("viewBox", "0 0 " + width + " " + 26);

    path.setAttribute("d", "M 3, 13 L " + (width - 3) + ", 13");

    circle.setAttribute("cx", 13);
    circle.setAttribute("cy", 13);
    circle.setAttribute("r", 10);
  }

  function updateTextGraphic(svg) {
    var path = svg.querySelector("path");
    var circle = svg.querySelector("circle");

    var width = svg.clientWidth;

    svg.setAttribute("viewBox", "0 0 " + width + " " + 26);

    path.setAttribute("d", "M 3, 13 L " + (width - 3) + ", 13");

    circle.setAttribute("cx", width - 13);
    circle.setAttribute("cy", 13);
    circle.setAttribute("r", 10);
  }

  function update() {
    var dateSvgs = document.querySelectorAll(".event-date-graphic");
    dateSvgs.forEach(function (container) {
      updateDateGraphic(container);
    });

    var textSvgs = document.querySelectorAll(".event-text-graphic");
    textSvgs.forEach(function (container) {
      updateTextGraphic(container);
    });
  }

  function init() {
    var dateSvgs = document.querySelectorAll(".event-date-graphic");

    dateSvgs.forEach(function (svg) {
      var path = document.createElementNS(xmlns, "path");
      var circle = document.createElementNS(xmlns, "circle");

      svg.appendChild(path);
      svg.appendChild(circle);
    });

    var textSvgs = document.querySelectorAll(".event-text-graphic");

    textSvgs.forEach(function (svg) {
      var path = document.createElementNS(xmlns, "path");
      var circle = document.createElementNS(xmlns, "circle");

      svg.appendChild(path);
      svg.appendChild(circle);
    });

    update();
  }

  return {
    init: init,
    update: update
  };
})();

eventGraphics.init();

});

// Debounce vertical update on resize
var debounceDelay = 250;
var debounceTimeout = null;

window.addEventListener('resize', function () {
  window.clearTimeout(debounceTimeout);
  debounceTimeout = window.setTimeout(function () {
    vertical.update();
    eventGraphics.update();
  }, debounceDelay);
});
